import React, { Component } from 'react';
import DisplayTraffic from './traffic/DisplayTraffic';
import { db } from '../config/firebase';

class Traffic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fix_me: false,
      unix_timestamp: 0,
      sum_viral: 0,
      viral_value_global: 0,
      sum_girlposts: 0,
      sum_twts: 0,
      value_global: 0,
      sum_realdonaldtrump: 0,
      sum_sodamntrue: 0,
      sum_freddyamazin: 0,
      sum_cnn: 0,
      sum_foxnews: 0,
      sum_nytimes: 0,
      sum_youtube: 0,
      sum_lmao: 0,
      sum_girlfriendnotes: 0,
      sum_country_voices: 0,
      sum_booty: 0,
      sum_ilgdaily: 0,
      sum_googlefacts: 0,
      sum_femaies: 0,
      sum_tumblrfunniez: 0,
      sum_relatablequote: 0,
      sum_soreiatable: 0,
      girlposts_value_global: 0,
      sodamntrue_value_global: 0,
      realdonaldtrump_value_global: 0,
      freddyamazin_value_global: 0,
      cnn_value_global: 0,
      foxnews_value_global: 0,
      nytimes_value_global: 0,
      youtube_value_global: 0,
      lmao_value_global: 0,
      girlfriendnotes_value_global: 0,
      country_voices_value_global: 0,
      booty_value_global: 0,
      ilgdaily_value_global: 0,
      googlefacts_value_global: 0,
      femaies_value_global: 0,
      tumblrfunniez_value_global: 0,
      relatablequote_value_global: 0,
      soreiatable_value_global: 0
    };
  }

  componentDidMount = () => {
    return [
      this.fetchTrafficLiveRecord(),
    ];
  };


  componentWillReceiveProps = (nextProps) => {
    let last_sum_twts = this.props.sum;
    let live_sum_twts = nextProps.sum_twts;

    if (last_sum_twts === live_sum_twts) {
      this.setState({
        fix_me: true
      });
    }

    // let fix_me = this.state.fix_me;

    // if ((last_sum_twts !== live_sum_twts)
    //   &&
    //   (fix_me === true)) {
    //   this.setState({
    //     fix_me: false
    //   });
    // }
  };

  fetchTrafficLiveRecord = async () => {
    let ref = db.ref(`record`).orderByKey().limitToLast(2);

    await ref.on('value', (record_data) => {

      let unix_timestamp = 0;
      let sum_viral = 0;
      let viral_value_global = 0;
      let girlposts_value_global = 0;
      let sodamntrue_value_global = 0;
      let realdonaldtrump_value_global = 0;
      let freddyamazin_value_global = 0;
      let cnn_value_global = 0;
      let foxnews_value_global = 0;
      let nytimes_value_global = 0;
      let youtube_value_global = 0;
      let sum_girlposts = 0;
      let sum_twts = 0;
      let sum_realdonaldtrump = 0;
      let sum_sodamntrue = 0;
      let sum_freddyamazin = 0;
      let sum_cnn = 0;
      let sum_foxnews = 0;
      let sum_nytimes = 0;
      let sum_youtube = 0;
      let sum_lmao = 0;
      let sum_girlfriendnotes = 0;
      let sum_country_voices = 0;
      let sum_booty = 0;
      let sum_ilgdaily = 0;
      let sum_googlefacts = 0;
      let sum_femaies = 0;
      let sum_tumblrfunniez = 0;
      let sum_relatablequote = 0;
      let sum_soreiatable = 0;
      let lmao_value_global = 0;
      let girlfriendnotes_value_global = 0;
      let country_voices_value_global = 0;
      let booty_value_global = 0;
      let ilgdaily_value_global = 0;
      let googlefacts_value_global = 0;
      let femaies_value_global = 0;
      let tumblrfunniez_value_global = 0;
      let relatablequote_value_global = 0;
      let soreiatable_value_global = 0;


      let reverse_data_array = [];
      record_data.forEach((date_data) => {
        date_data.forEach((hour_data) => {
          hour_data.forEach((min_data) => {
            reverse_data_array.push(min_data.val());
          });
        });
      });

      let data_array = reverse_data_array.reverse();

      let i = 0;
      data_array.map((val) => {
        if (i === 0) {
          unix_timestamp = val.unix_timestamp;
        }
        if (i < 10) {
          i++;

          sum_viral += val.sum_viral;
          viral_value_global += val.viral_value_global;
          girlposts_value_global += val.girlposts_value_global;
          sodamntrue_value_global += val.sodamntrue_value_global;
          realdonaldtrump_value_global += val.realdonaldtrump_value_global;
          freddyamazin_value_global += val.freddyamazin_value_global;
          cnn_value_global += val.cnn_value_global;
          foxnews_value_global += val.foxnews_value_global;
          nytimes_value_global += val.nytimes_value_global;
          youtube_value_global += val.youtube_value_global;
          sum_girlposts += val.sum_girlposts;
          sum_twts += val.sum_twts;
          sum_realdonaldtrump += val.sum_realdonaldtrump;
          sum_sodamntrue += val.sum_sodamntrue;
          sum_freddyamazin += val.sum_freddyamazin;
          sum_cnn += val.sum_cnn;
          sum_foxnews += val.sum_foxnews;
          sum_nytimes += val.sum_nytimes;
          sum_youtube += val.sum_youtube;
          sum_lmao += val.sum_lmao;
          sum_girlfriendnotes += val.sum_girlfriendnotes;
          sum_country_voices += val.sum_country_voices;
          sum_booty += val.sum_booty;
          sum_ilgdaily += val.sum_ilgdaily;
          sum_googlefacts += val.sum_googlefacts;
          sum_femaies += val.sum_femaies;
          sum_tumblrfunniez += val.sum_tumblrfunniez;
          sum_relatablequote += val.sum_relatablequote;
          sum_soreiatable += val.sum_soreiatable;
          lmao_value_global += val.lmao_value_global;
          girlfriendnotes_value_global += val.girlfriendnotes_value_global;
          country_voices_value_global += val.country_voices_value_global;
          booty_value_global += val.booty_value_global;
          ilgdaily_value_global += val.ilgdaily_value_global;
          googlefacts_value_global += val.googlefacts_value_global;
          femaies_value_global += val.femaies_value_global;
          tumblrfunniez_value_global += val.tumblrfunniez_value_global;
          relatablequote_value_global += val.relatablequote_value_global;
          soreiatable_value_global += val.soreiatable_value_global;
        }
      });

      this.setState({
        unix_timestamp: unix_timestamp,
        sum_viral: sum_viral,
        viral_value_global: viral_value_global / 10,
        girlposts_value_global: girlposts_value_global / 10,
        sodamntrue_value_global: sodamntrue_value_global / 10,
        realdonaldtrump_value_global: realdonaldtrump_value_global / 10,
        freddyamazin_value_global: freddyamazin_value_global / 10,
        cnn_value_global: cnn_value_global / 10,
        foxnews_value_global: foxnews_value_global / 10,
        nytimes_value_global: nytimes_value_global / 10,
        youtube_value_global: youtube_value_global / 10,
        sum_girlposts: sum_girlposts,
        sum_twts: sum_twts,
        sum_realdonaldtrump: sum_realdonaldtrump,
        sum_sodamntrue: sum_sodamntrue,
        sum_freddyamazin: sum_freddyamazin,
        sum_cnn: sum_cnn,
        sum_foxnews: sum_foxnews,
        sum_nytimes: sum_nytimes,
        sum_youtube: sum_youtube,
        sum_lmao: sum_lmao,
        sum_girlfriendnotes: sum_girlfriendnotes,
        sum_country_voices: sum_country_voices,
        sum_booty: sum_booty,
        sum_ilgdaily: sum_ilgdaily,
        sum_googlefacts: sum_googlefacts,
        sum_femaies: sum_femaies,
        sum_tumblrfunniez: sum_tumblrfunniez,
        sum_relatablequote: sum_relatablequote,
        sum_soreiatable: sum_soreiatable,
        lmao_value_global: lmao_value_global / 10,
        girlfriendnotes_value_global: girlfriendnotes_value_global / 10,
        country_voices_value_global: country_voices_value_global / 10,
        booty_value_global: booty_value_global / 10,
        ilgdaily_value_global: ilgdaily_value_global / 10,
        googlefacts_value_global: googlefacts_value_global / 10,
        femaies_value_global: femaies_value_global / 10,
        tumblrfunniez_value_global: tumblrfunniez_value_global / 10,
        relatablequote_value_global: relatablequote_value_global / 10,
        soreiatable_value_global: soreiatable_value_global / 10
      });
    });
  };

  render() {

    let {
      unix_timestamp,
      fix_me,
      sum_girlposts,
      sum_viral,
      viral_value_global,
      sum_twts,
      sum_realdonaldtrump,
      sum_sodamntrue,
      sum_freddyamazin,
      sum_cnn,
      sum_foxnews,
      sum_nytimes,
      sum_youtube,
      sum_lmao,
      sum_girlfriendnotes,
      sum_country_voices,
      sum_booty,
      sum_ilgdaily,
      sum_googlefacts,
      sum_femaies,
      sum_tumblrfunniez,
      sum_relatablequote,
      sum_soreiatable,
      girlposts_value_global,
      sodamntrue_value_global,
      realdonaldtrump_value_global,
      freddyamazin_value_global,
      cnn_value_global,
      foxnews_value_global,
      nytimes_value_global,
      youtube_value_global,
      lmao_value_global,
      girlfriendnotes_value_global,
      country_voices_value_global,
      booty_value_global,
      ilgdaily_value_global,
      googlefacts_value_global,
      femaies_value_global,
      tumblrfunniez_value_global,
      relatablequote_value_global,
      soreiatable_value_global
    }
      = this.state;

    return (
      <div>
        {fix_me &&
        <div style={{
          position: 'absolute',
          fontSize: '22px',
          top: 0,
          left: 0,
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          margin: '60px 0 0 0',
          color: 'deepskyblue',
          fontStyle: 'italic',
          fontWeight: 'bold'
        }}>
          *paused*
        </div>
        }
        <div>
          <DisplayTraffic sum_girlposts={sum_girlposts}
                          unix_timestamp={unix_timestamp}
                          sum_twts={sum_twts}
                          sum_viral={sum_viral}
                          viral_value_global={viral_value_global}
                          sum_realdonaldtrump={sum_realdonaldtrump}
                          sum_sodamntrue={sum_sodamntrue}
                          sum_freddyamazin={sum_freddyamazin}
                          sum_cnn={sum_cnn}
                          sum_foxnews={sum_foxnews}
                          sum_nytimes={sum_nytimes}
                          sum_youtube={sum_youtube}
                          girlposts_value_global={girlposts_value_global}
                          sodamntrue_value_global={sodamntrue_value_global}
                          freddyamazin_value_global={freddyamazin_value_global}
                          cnn_value_global={cnn_value_global}
                          foxnews_value_global={foxnews_value_global}
                          nytimes_value_global={nytimes_value_global}
                          youtube_value_global={youtube_value_global}
                          realdonaldtrump_value_global
                            ={realdonaldtrump_value_global}
                          sum_lmao={sum_lmao}
                          sum_girlfriendnotes={sum_girlfriendnotes}
                          sum_country_voices={sum_country_voices}
                          sum_booty={sum_booty}
                          sum_ilgdaily={sum_ilgdaily}
                          sum_googlefacts={sum_googlefacts}
                          sum_femaies={sum_femaies}
                          sum_tumblrfunniez={sum_tumblrfunniez}
                          sum_relatablequote={sum_relatablequote}
                          sum_soreiatable={sum_soreiatable}
                          lmao_value_global={lmao_value_global}
                          girlfriendnotes_value_global
                            ={girlfriendnotes_value_global}
                          country_voices_value_global
                            ={country_voices_value_global}
                          booty_value_global={booty_value_global}
                          ilgdaily_value_global={ilgdaily_value_global}
                          googlefacts_value_global={googlefacts_value_global}
                          femaies_value_global={femaies_value_global}
                          tumblrfunniez_value_global={tumblrfunniez_value_global}
                          relatablequote_value_global
                            ={relatablequote_value_global}
                          soreiatable_value_global={soreiatable_value_global}

          />
        </div>
      </div>
    );
  }
}


export default Traffic;


// WEBPACK FOOTER //
// ./src/containers/Traffic.js